<template>
    <div>
        <BRow class="mb-3">
            <BCol md="12">
                <div class="d-flex justify-content-end align-items-center mb-3">
                    <BButton variant="outline-primary" size="sm" @click="openModal">
                        <i class="fas fa-plus"></i> Add Entrance Fee
                    </BButton>
                </div>

                <BTableSimple hover small responsive bordered striped>
                    <BThead head-variant="light">
                        <BTr>
                            <BTh>No</BTh>
                            <BTh>Name</BTh>
                            <BTh class="text-center">Qty</BTh>
                            <BTh class="text-end">Amount</BTh>
                            <BTh class="text-end">Subtotal</BTh>
                            <BTh class="text-center" style="width: 100px">Action</BTh>
                        </BTr>
                    </BThead>
                    <BTbody>
                        <BTr v-for="(item, index) in form.entrance_fees" :key="index">
                            <BTd>{{ index + 1 }}</BTd>
                            <BTd>{{ item.name }}</BTd>
                            <BTd class="text-center">{{ item.qty }}</BTd>
                            <BTd class="text-end">{{ formatCurrency(item.amount) }}</BTd>
                            <BTd class="text-end">{{ formatCurrency(item.subtotal) }}</BTd>
                            <BTd class="text-center">
                                <BButton variant="warning" size="sm" class="me-1" @click="editItem(index)">
                                    <i class="fas fa-edit"></i>
                                </BButton>
                                <BButton variant="danger" size="sm" @click="removeItem(index)">
                                    <i class="fas fa-trash"></i>
                                </BButton>
                            </BTd>
                        </BTr>
                        <BTr v-if="form.entrance_fees.length === 0">
                            <BTd colspan="6" class="text-center text-muted">No entrance fees added.</BTd>
                        </BTr>
                    </BTbody>
                    <BTfoot>
                        <BTr>
                            <BTh colspan="4" class="text-end">Total Entrance Fee</BTh>
                            <BTh class="text-end">{{ formatCurrency(total) }}</BTh>
                            <BTh></BTh>
                        </BTr>
                    </BTfoot>
                </BTableSimple>
            </BCol>
        </BRow>

        <!-- Component Form -->
        <EntranceFeeForm v-if="modalVisible"
            :modal="modalVisible" 
            @update:modal="modalVisible = $event"
            :selected-data="selectedItem" 
            @add-or-update="handleSave" 
        />
    </div>
</template>

<script setup>
import { inject, computed, ref } from "vue";
import { BRow, BCol, BButton, BTableSimple, BThead, BTbody, BTfoot, BTr, BTh, BTd } from "bootstrap-vue-next";
import EntranceFeeForm from "../EntranceFeeForm.vue";

const form = inject('form');
const modalVisible = ref(false);
const editIndex = ref(-1);
const selectedItem = ref(null);

const openModal = () => {
    editIndex.value = -1;
    selectedItem.value = null;
    modalVisible.value = true;
};

const editItem = (index) => {
    editIndex.value = index;
    // Clone to avoid direct mutation affecting parent before save
    selectedItem.value = { ...form.entrance_fees[index], index }; 
    modalVisible.value = true;
};

const handleSave = (payload) => {
    if (editIndex.value === -1) {
        form.entrance_fees.push(payload);
    } else {
        form.entrance_fees[editIndex.value] = payload;
    }
    modalVisible.value = false;
};

const removeItem = (index) => {
    form.entrance_fees.splice(index, 1);
};

const total = computed(() => {
    return form.entrance_fees.reduce((sum, item) => sum + (parseFloat(item.subtotal) || 0), 0);
});

const formatCurrency = (val) => {
    return new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR', minimumFractionDigits: 0 }).format(val);
};
</script>
